import React, { useEffect } from 'react';
import { Form, Space } from 'antd';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setJobTemplatePayload } from 'redux/jobs/jobTemplates/slice';
import { getJobTemplateConfigSelector } from 'redux/jobs/jobTemplates/selectors';
import i18next from 'i18next';
import { cleanObject } from 'utils/dataUtils';
import useWindowAutoScroll from 'hooks/useWindowAutoScroll';
import { isEmpty } from 'lodash-es';
import TableToggle from '../../TableToggle';

const CertificationsForm = ({ form, initTemplate }) => {
  useWindowAutoScroll();
  const dispatch = useDispatch();

  const { certifications = [] } = useSelector(getJobTemplateConfigSelector);

  const onFinish = (certifications) => {
    dispatch(
      setJobTemplatePayload({ certifications: cleanObject(certifications) }),
    );
  };

  useEffect(() => {
    form.resetFields();
    if (!isEmpty(initTemplate?.certifications)) {
      form.setFieldsValue(initTemplate?.certifications);
    }
  }, [form, initTemplate]);

  return (
    <div>
      <Form form={form} onFinish={onFinish}>
        <Space direction="vertical" size={24} className="w-full">
          <TableToggle
            dataSource={certifications}
            categoryName={i18next.t(
              'jobs.createJobTemplateStep.certifications',
            )}
          />
        </Space>
      </Form>
    </div>
  );
};

CertificationsForm.propTypes = {
  form: PropTypes.object,
  initTemplate: PropTypes.object,
};

export default CertificationsForm;
